import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RefreshTokenService } from './refresh-token.service';
import { GrunddatenService } from '../grundlagen/grunddaten.service';
import { Title } from '@angular/platform-browser';
import { FehlerService } from '../grundlagen/fehler.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const titleService = inject(Title);
  const grundlagen = inject(GrunddatenService);
  const refreshTokenService = inject(RefreshTokenService);

  if (!grundlagen.CheckTokenAktuell() || !grundlagen.isBenutzerRechtGesetzt()) {
    localStorage.setItem('requestURL', state.url);
    refreshTokenService.refreshingTokens();
  }

  if (!grundlagen.CheckTokenAktuell()) {
    router.navigateByUrl('/fehler');
    return false;
  }

  if (grundlagen.checkMenuGesperrt(state.url)) {
    grundlagen.aufgerufeneURL.set(state.url);
    router.navigateByUrl('/fehler');
    return false;
  }

  if (route.data['roles']) {
    const rolle = route.data['roles'] as bigint;
    if (!grundlagen.benutzerHatRecht(rolle)) {
      grundlagen.aufgerufeneURL.set(state.url);

      const fs = inject(FehlerService);
      const fehlerText = `${state.url}: Benutzer: ${grundlagen.benutzerId()} (Rechte: ${grundlagen.benutzerRolle})`;
      fs.FehlerBericht('Auth-Guard', fehlerText);
      router.navigateByUrl('/fehler');
      return false;
    }
  }

  titleService.setTitle(route.data['title'] ? route.data['title'] + ' - WEB-VA' : 'LogiServe WEB-VA');

  return true;
};
